import { Button, Col, Form, Row, Upload } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { InitialData } from '../../common/InitialData';
import { Formik } from 'formik';
import FileUploadWithThumbnails from '../LoanApplication/FileUploadWithThumbnails';

const DisbursementDoc = ({ updateFunction, filterData }) => {
    const [disbursementDoc, setDisbursementDoc] = useState({});
    useEffect(() => {
        setDisbursementDoc(InitialData.disbursement_documents);
    }, [])
    return (
        <div>
            <Formik initialValues={disbursementDoc} onSubmit={(values, { setSubmitting }) => { }}>
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                    <Form layout="vertical" onSubmit={handleSubmit}>
                        <Row gutter={[16, 16]}>
                            <FileUploadWithThumbnails label={"Transaction History"} maxfile={3} size={6} datakey={'disbursement_docs'} dataApiKey={'transaction_history'} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Vehicle Information"} maxfile={3} size={6} datakey={'disbursement_docs'} dataApiKey={'vehicle_information'} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Vehicle Acknowledgement"} maxfile={3} size={8} datakey={'disbursement_docs'} dataApiKey={'vehicle_acknowledgement'} updateFunction={updateFunction} />
                        </Row>
                        <Row gutter={[16, 16]}>
                            <FileUploadWithThumbnails label={"Certificate of Insurance"} maxfile={3} size={6} datakey={'disbursement_docs'} dataApiKey={'insurance_certificate'} updateFunction={updateFunction} />
                            <FileUploadWithThumbnails label={"Number Retention Letter (Optional)"} maxfile={3} size={6} datakey={'disbursement_docs'} dataApiKey={'number_retention_letter'} updateFunction={updateFunction} />
                        </Row>
                    </Form>
                )}
            </Formik>
        </div >
    );
};

export default DisbursementDoc;